


































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getMarketStaffListApi } from "@/api/marketActivity";
import { staffList } from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() originData: any;
  dialogVisible: boolean = false;
  searchInfo: any = {
    staff_id: "",
  };
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  selectItem: any[] = [];
  market_staff_list: any[] = [];
  selectedList: any[] = [];
  selectedObject: any = [];
  timer: any;
  @Watch("dialogVisible")
  onChangeValue(n: any) {
    if (n) {
      this.getList();
      this.getMarketStaffListApiFn();
    }
  }
  handleShowDialog() {
    this.dialogVisible = true;
    this.selectedList = this.originData;
    const obj: any = {};
    this.originData.map((item: any) => {
      obj[item.staff_id] = item;
    });
    this.selectedObject = obj;
  }
  handleCloseDialog() {
    this.pageSize = 10;
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.searchInfo.staff_id) {
      params.market_staff_id = this.searchInfo.staff_id;
    }
    params.status = 1;
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    getMarketStaffListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.forEach((item: any) => {
          if (this.selectedObject[item.staff_id]) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          item.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(item.create_time * 1000)
          );
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  // 获取市场顾问列表
  getMarketStaffListApiFn(v?: any) {
    staffList({
      page: 1,
      page_size: 100,
      key_word: v,
      status: 1,
      job_ids: [4],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.debounce(this.getMarketStaffListApiFn, v, 500);
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  // 处理多选框选中与否
  handleTeacherSelect(row?: any) {
    const copy = { ...this.selectedObject };
    if (copy[row.staff_id]) {
      delete copy[row.staff_id];
    } else {
      copy[row.staff_id] = row;
    }
    this.selectedObject = copy;

    const items = [];
    for (const key in copy) {
      items.unshift(copy[key]);
    }
    this.selectedList = items;

    const index = this.tableData.findIndex((item: any) => {
      return item.staff_id === row.staff_id;
    });

    if (index >= 0) {
      this.tableData[index].checked = !!copy[row.staff_id];
    }
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  confirmSubmit() {
    let ids: any[] = [];
    this.selectedList.map((item: any) => {
      ids.push(Number(item.staff_id));
    });
    this.dialogVisible = false;
    this.searchInfo.staff_id = "";
    this.$emit("change", this.selectedList);
  }
  debounce(fn: any, data: any, delay: any) {
    // 设置一个触发开关
    let _t = this;
    clearTimeout(_t.timer);
    _t.timer = setTimeout(() => {
      fn(data);
    }, delay);
  }
}
